import { EFinancingProgram, ELoanSystemId, SystemFlowConfiguration, SystemFlowSwitch } from '@if/core/types'

class LoanFlowConfig {
  public readonly financingProgramConfig: Record<EFinancingProgram, SystemFlowConfiguration>
  constructor(systemFlowSwitch: SystemFlowSwitch) {
    if (!systemFlowSwitch) {
      this.financingProgramConfig = {} as Record<EFinancingProgram, SystemFlowConfiguration>
    } else {
      this.financingProgramConfig = systemFlowSwitch.systemFlowConfig
    }
  }

  public hasWriteAccess(financingProgram: EFinancingProgram): boolean {
    const config = this.financingProgramConfig[financingProgram]
    if (!config) return true
    return config.readWrite === ELoanSystemId.LMS
  }
}

export default LoanFlowConfig
